// Report Configuration - Categories and Endpoints
import { 
  BarChart3, Calendar, PieChart, Users, Banknote, TrendingUp,
  BookOpen, Scale, Landmark, Eye, AlertCircle, DollarSign,
  Building2, Zap, Calculator, Briefcase, Percent
} from 'lucide-react';

export const reportCategories = [
  {
    id: 'revenue',
    label: 'Revenue & Profitability',
    reports: [
      { id: 'executive', label: 'Executive Summary', icon: BarChart3 },
      { id: 'dailyfunding', label: 'Daily Funding', icon: Calendar },
      { id: 'dividendinout', label: 'Dividend In/Out', icon: Percent },
      { id: 'pnlsymbol', label: 'P&L by Symbol', icon: PieChart },
      { id: 'clientprofit', label: 'Client Profitability', icon: Users },
      { id: 'commission', label: 'Commission', icon: Banknote },
      { id: 'depositflow', label: 'Deposits', icon: TrendingUp },
    ]
  },
  {
    id: 'risk',
    label: 'Risk & Compliance',
    reports: [
      { id: 'books', label: 'A/B/C Books', icon: BookOpen },
      { id: 'hedging', label: 'Hedging', icon: Scale },
      { id: 'regulatory', label: 'Regulatory', icon: Landmark },
      { id: 'suspicious', label: 'AML Alerts', icon: Eye },
      { id: 'margincalls', label: 'Margin Calls', icon: AlertCircle },
    ]
  },
  {
    id: 'operations',
    label: 'Operations & Investor',
    reports: [
      { id: 'financial', label: 'P&L Statement', icon: DollarSign },
      { id: 'balance', label: 'Balance Sheet', icon: Building2 },
      { id: 'execution', label: 'Execution', icon: Zap },
      { id: 'valuation', label: 'Valuation', icon: Calculator },
      { id: 'investor', label: 'Investor', icon: Briefcase },
    ]
  }
];

export const endpoints = {
  executive: '/api/ceo-reports/executive-summary',
  financial: '/api/ceo-reports/financial-statement',
  balance: '/api/ceo-reports/balance-sheet',
  clients: '/api/ceo-reports/client-analytics',
  trading: '/api/ceo-reports/trading-analytics',
  risk: '/api/ceo-reports/risk-report',
  investor: '/api/ceo-reports/investor-report',
  books: '/api/ceo-reports/book-analysis',
  margincalls: '/api/ceo-reports/margin-calls',
  pnlsymbol: '/api/ceo-reports/pnl-by-symbol',
  clientprofit: '/api/ceo-reports/client-profitability',
  commission: '/api/ceo-reports/commission-analytics',
  depositflow: '/api/ceo-reports/deposit-withdrawal',
  hedging: '/api/ceo-reports/hedging-efficiency',
  regulatory: '/api/ceo-reports/regulatory-capital',
  suspicious: '/api/ceo-reports/suspicious-activity',
  execution: '/api/ceo-reports/execution-quality',
  valuation: '/api/ceo-reports/exit-valuation',
  dailyfunding: '/api/ceo-reports/daily-funding',
  dividendinout: '/api/ceo-reports/dividend-inout'
};
